/*
  Siltcon Auréa: de leverregel op elke pagina.
  Altijd gerekend in de tijdzone Europe/Amsterdam, niet in de tijd van de bezoeker.
  Maandag tot en met vrijdag: "Voor 23:59 besteld, morgen in huis".
  Zaterdag en zondag: "Op zaterdag of zondag besteld, maandag in huis".
  Elementen met data-aurea-lever="aftel" tonen op maandag tot en met vrijdag een aftelling tot 23:59,
  die elke minuut bijgewerkt wordt. Elementen met data-aurea-lever="tekst" tonen alleen de regel.
  Elementen met data-aurea-lever="wagen" (de balk in de winkelwagen) tonen dezelfde aftelling als
  "Bestel binnen [tijd] en ontvang hem morgen gratis in huis"; in het weekend en om 23:59 de regel met "gratis".
  Zonder JavaScript blijft de servertekst staan: "Voor 23:59 besteld, morgen in huis".
*/
(() => {
  const TIJDZONE = 'Europe/Amsterdam';
  const WEEKEND = 'Op zaterdag of zondag besteld, maandag in huis';
  const WERKDAG = 'Voor 23:59 besteld, morgen in huis';
  const WEEKEND_WAGEN = 'Op zaterdag of zondag besteld, maandag gratis in huis';
  const WERKDAG_WAGEN = 'Voor 23:59 besteld, morgen gratis in huis';
  const opmaak = new Intl.DateTimeFormat('en-US', {
    timeZone: TIJDZONE,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  /** Dag en tijd van nu in Amsterdam. */
  const amsterdam = () => {
    const delen = {};
    opmaak.formatToParts(new Date()).forEach((deel) => (delen[deel.type] = deel.value));
    return {
      weekend: delen.weekday === 'Sat' || delen.weekday === 'Sun',
      seconden: Number(delen.hour) * 3600 + Number(delen.minute) * 60 + Number(delen.second),
    };
  };

  /** @param {{weekend: boolean, seconden: number}} nu */
  const regel = (nu) => {
    if (nu.weekend) return { tekst: WEEKEND, aftel: WEEKEND, wagen: WEEKEND_WAGEN };
    const minuten = Math.ceil((23 * 3600 + 59 * 60 - nu.seconden) / 60);
    if (minuten < 1) return { tekst: WERKDAG, aftel: WERKDAG, wagen: WERKDAG_WAGEN };
    const uren = Math.floor(minuten / 60);
    const rest = minuten % 60;
    const delen = [];
    if (uren > 0) delen.push(`${uren} uur`);
    if (rest > 0 || uren === 0) delen.push(`${rest} min`);
    const tijd = delen.join(' en ');
    return {
      tekst: WERKDAG,
      aftel: `Bestel binnen ${tijd}, morgen in huis`,
      wagen: `Bestel binnen ${tijd} en ontvang hem morgen gratis in huis`,
    };
  };

  const werkBij = () => {
    const nu = regel(amsterdam());
    document.querySelectorAll('[data-aurea-lever]').forEach((el) => {
      const soort = el.getAttribute('data-aurea-lever');
      const nieuw = soort === 'aftel' ? nu.aftel : soort === 'wagen' ? nu.wagen : nu.tekst;
      if (el.textContent !== nieuw) el.textContent = nieuw;
    });
  };

  /** Werk bij op elke hele minuut. */
  const plan = () => {
    werkBij();
    setTimeout(plan, 60000 - (Date.now() % 60000) + 50);
  };

  // De winkelwagenlade (assets/aurea-wagen.js) roept dit aan na het verversen van haar inhoud.
  window.aureaLeverWerkBij = werkBij;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', plan);
  } else {
    plan();
  }
})();
